<template>
  <div>
    <v-data-table
      v-if="cards.length > 0"
      :headers="headers"
      :items="cards"
      :items-per-page="10"
      @click:row="
        (item) =>
          $router.push({
            name: 'cartes-details',
            params: { id: item.id },
          })
      "
    >
    </v-data-table>
    <div v-else>Pas de cartes pour ce client.</div>
  </div>
</template>
<script>
export default {
  props: {
    cards: Array,
  },
  setup() {
    return {
      headers: [
        { text: "Login", value: "id" },
        { text: "Password", value: "password" },
        { text: "Nom", value: "profile.lastname" },
        { text: "Prénom", value: "profile.firstname" },
        { text: "Créé le", value: "createdAt" },
        { text: "Durée totale de connexion", value: "totalConnectionDuration" },
        { text: "Origine", value: "cardOrigin.description" },
      ],
    };
  },
};
</script>
